module.exports = __webpack_public_path__ + "img/cintas.520ae8ab.jpg";